import * as React from "react";
import { Transition } from "react-transition-group";

export interface AnimationProps {
  children: React.ReactChildren;
  data: any;
  defaultStyle: { [index: string]: string };
  name: string;
  style: React.CSSProperties;
  timeout: number;
  transitionStyles: { [index: string]: { [index: string]: string } };
}

class Animation extends React.Component<AnimationProps> {
  state = {
    enterAnimation: false,
  };

  componentDidMount() {
    this.setState({ enterAnimation: true });
  }

  componentDidUpdate(prevProps: AnimationProps) {
    const { name, data } = this.props;
    const startExitAnimation =
      !prevProps.data.exitAnimations[name] && data.exitAnimations[name];

    if (startExitAnimation) {
      this.setState({ enterAnimation: false });
    }
  }

  render() {
    const { children, defaultStyle, style, timeout, transitionStyles } =
      this.props;

    const transitionProps = {
      in: this.state.enterAnimation,
      timeout: timeout || 0,
    };

    return (
      <Transition {...transitionProps}>
        {(state) => {
          return (
            <div
              style={{
                ...style,
                ...defaultStyle,
                ...transitionStyles[state],
              }}
            >
              {children}
            </div>
          );
        }}
      </Transition>
    );
  }
}

export default Animation;
